import { ProductLine, ProductLineForm } from "../../../api/client-api/productLines/useProductLines";
import { ProductLineWrite } from "../../../api/client-api/productLines/useCreateProductLine";

export class ProductLineService {
    static getProductLinesToProductLineForms = (existingProductLines?: ProductLine[]): ProductLineForm[] => {
        return (
            existingProductLines?.map((productLine) => {
                return {
                    id: productLine.id,
                    name: productLine.name,
                    parent: productLine.parent,
                    products: productLine.products,
                    canView: productLine.canView,
                    canModify: productLine.canModify,
                    canDelete: productLine.canDelete,
                };
            }) || []
        );
    };

    static getProductLineToProductLineWrite = (productLine: ProductLineForm): ProductLineWrite => {
        const productLineWrite: ProductLineWrite = {
            id: productLine.id,
            name: productLine.name,
            parent: productLine.parent?.["@id"] || null,
        };

        return productLineWrite;
    };
}
